export default __webpack_public_path__ + "static/banner-desktop-6f188841ba52f8a53aff9e060ae0a2a6.png";